import React from "react";
import { Helmet } from "react-helmet-async";

const SITE = "PortugalManga";
const DEFAULT_DESC = "A base de dados portuguesa de mangá — coleção, comunidade, lançamentos e novidades.";
const BASE_URL = "https://portugalmanga.pt";

// Reusable SEO / social meta tags. Googlebot renders these client-side.
export default function Seo({ title, description, image, path, type = "website" }) {
  const fullTitle = title ? `${title} · ${SITE}` : SITE;
  const desc = description || DEFAULT_DESC;
  const url = path ? `${BASE_URL}${path}` : BASE_URL;
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={SITE} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      {image && <meta property="og:image" content={image} />}
      <meta name="twitter:card" content={image ? "summary_large_image" : "summary"} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      {image && <meta name="twitter:image" content={image} />}
    </Helmet>
  );
}
